import axios from '@/api/axiosInstance';

export default async function getRealTimeActivity(realTimeActivityId) {
  const response = await axios({
    url: `${process.env.NEXT_PUBLIC_API}/realTimeActivities/${realTimeActivityId}`,
    method: 'get',
  });
  return response.data;
}
